import React, { Component } from 'react';

import SessionList from '../components/SessionList';

class CourseView extends Component {

  render() {
    const { match } = this.props;
    return (
      <SessionList courseId={match.params.courseId} />
    );
  }

}

export default CourseView;



// WEBPACK FOOTER //
// ./src/views/CourseView.js